import React from 'react'
import './BrowserWarning.css'
import { crossBtnIcon } from '../../../images/btnIcons'
import LanguageTranslater from '../../HOC/LanguageTranslater'
import { getDevice, validBrowserForNewUi } from '../../../utils/getDevice'

function BrowserWarning({ translate }) {
    return (
        <div className='policy-splt-otp-cntnr'>
            <div className='policy-splt-otp-img'>
                <img src={crossBtnIcon} alt="crossmark" />
            </div>

            <div className='policy-splt-otp-para-txt'>
                {getDevice() == "desktop" && <p>
                    Desktop is Not supported. Please use Mobile for Completing your Journey.
                </p>}
                {
                    !validBrowserForNewUi() && <p>Browser is Not Supported. Please use chrome/safari for Completing your Journey.</p>
                }

            </div>
            {/* <div className='policy-splt-otp-button'>
                <button>{translate("Close this page")}</button>
            </div> */}
        </div>
    )
}

export default LanguageTranslater(BrowserWarning)